import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';

const images = [
  "/sustain2.webp",
  "/sustain3.webp",
  "/sustain1.webp",
  "/sustain4.webp",
  "/Glass-mobile.webp",
  "/iot2.webp",
  "/greenhouse7.jpg",
  "/innovation1.webp",
  "/auto.webp",
  "/greenhouse6.jpg",
  "/polycarbonate7.webp",
  "/polycarbonate6.jpg",
  "/polycarbonate2.webp",
  "/polycarbonate10.webp",
  "/screenhouse5.webp",
  "/mobile.webp",
  "/mb-hero5.webp",
  "/polycarbonate9.webp",
  "/greenhouse-collage.webp",
  "/commit4.webp",
  "/merge.jpeg",
  "/2.webp",
  "/about4.webp",
  "/greenhouse2.jpg",
];

const AnimatedImage: FC<{ src: string; alt: string; index: number }> = ({ src, alt, index }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="aspect-square overflow-hidden"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.96)',
        transition: `opacity 0.6s ease, transform 0.6s ease`,
        transitionDelay: `${(index % 4) * 80}ms`,
      }}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
      />
    </div>
  );
};

const Multiimages: FC = () => {
  return (
    <div className="w-full bg-white p-1">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1">
        {images.map((src, i) => (
          <AnimatedImage key={i} src={src} alt={`img-${i + 1}`} index={i} />
        ))}
      </div>
    </div>
  );
};

export default Multiimages;